const BidModifierParentType = Object.freeze({
  CATEGORY: "category",
  SELLER_OFFER: "seller-offer",
  SELLER_OFFER_REGISTRATION: "seller-offer-registration",
})
  
export default BidModifierParentType